import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

// icons
import { ChevronLeft } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "jalali-moment";

export default function OrderRow({ item }) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");
  const spliter = (word, limit) => {
    const nums = word.split(" ").slice(0, limit);
    const add = nums.length >= limit ? "..." : "";
    return nums.join(" ") + add;
  };
  return (
    <Accordion
      sx={{
        border: "none",
        bgcolor: "transparent",
        borderRadius: "10px !important",
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        sx={{
          borderBottom: "none",
          "&.Mui-expanded": {
            borderBottom: `2px solid ${theme.palette.secondary.main}`,
          },
          width: "100%",
          direction: "rtl",

          color: theme.palette.primary.main,
          bgcolor: theme.palette.background.paper,

          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.primary.main,
            transition: "transform 0.3s",
          },
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(-90deg)",
            color: theme.palette.primary.main,
          },
        }}
        expandIcon={<ChevronLeft />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            width: "100%",
            px: { xs: "0", sm: "12px" },
          }}
        >
          <Typography
            component={"span"}
            sx={{
              color: theme.palette.primary.main,
              fontSize: { xs: "12px", sm: "14px", md: "1rem" },
            }}
          >
            {"کدپیگیری :" + " " + item?.payment_details?.sale_reference_id}
          </Typography>
          <Typography
            component={"span"}
            sx={{
              color: theme.palette.primary.main,
              fontSize: { xs: "12px", sm: "14px", md: "1rem" },
            }}
          >
            {"تاریخ :" +
              " " +
              moment.unix(item?.created_at).format("jYYYY/jMM/jDD")}
          </Typography>
          <Typography
            component={"span"}
            sx={{
              color: theme.palette.primary.main,
              fontSize: { xs: "12px", sm: "14px", md: "1rem" },
            }}
          >
            {"مبلغ :" +
              " " +
              item?.payment_statics?.total_price?.toLocaleString()}
          </Typography>
        </Stack>
      </AccordionSummary>

      {/* Second Map */}
      <AccordionDetails
        sx={{ bgcolor: theme.palette.background.lightCream, p: "0" }}
      >
        {item?.cart?.map((e, indexx) => {
          return (
            <Stack
              key={indexx + "item"}
              direction={"row"}
              sx={{
                justifyContent: "space-between",
                padding: "16px 8px",
                borderBottom: `2px solid ${theme.palette.primary.lowOpacity}`,
                px: { xs: ".5rem", md: "2rem" },
              }}
            >
              <Typography
                component={"span"}
                sx={{ color: theme.palette.background.main, direction: "rtl" }}
              >
                {Number(e?.price).toLocaleString()}
              </Typography>
              <Stack direction={"row"} sx={{ direction: "rtl", gap: "8px" }}>
                <Typography
                  component={"span"}
                  sx={{
                    color: theme.palette.background.main,
                    direction: "rtl",
                  }}
                >
                  {isMobile ? spliter(e?.name, 5) : spliter(e?.name, 12)}
                </Typography>
                <Typography
                  component={"div"}
                  sx={{
                    color: theme.palette.primary.main,
                    direction: "ltr",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {" " + e?.quantity + " "}{" "}
                  <CloseIcon
                    sx={{ fontSize: "14px", color: theme.palette.primary.main }}
                  />
                </Typography>
              </Stack>
            </Stack>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}
